'use strict';
module.exports = object => Object.keys(object).map(i => object[i]);



// WEBPACK FOOTER //
// ./node_modules/object-values/index.js